import { EntryPage } from "lib/entries/types";
import { EntriesRequestFilters } from "lib/entries/types";
import { Pagination } from "gui/pagination/pagination";

export const EntriesPagination: React.FC<{
  page: EntryPage<any>;
  entriesRequestFilters: EntriesRequestFilters;
  setEntriesRequestFilters: (
    entriesRequestFilters: EntriesRequestFilters
  ) => void;
}> = (props) => {
  const onClick = (page: number) => () => {
    props.setEntriesRequestFilters({ ...props.entriesRequestFilters, page });
  };

  return (
    <Pagination page={props.page}>
      {(text: React.ReactNode, page: number, current: boolean) => (
        <button type="button" onClick={onClick(page)} aria-current={current}>
          {text}
        </button>
      )}
    </Pagination>
  );
};
